module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff?31d47085569e772c0f57aa8ec8381a5c";